import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';
import Icon, { IconEnum } from '../../../../../components/icon';
import { useAsync } from '../../../../../hooks/useAsync';
import { GetOTPResponse, OneTimePasswordClient } from '../../../../../services/partnerCenterService';

interface CopyInvitationLinkProps {
    instanceId: string;
}

const CopyInvitationLink: React.FC<CopyInvitationLinkProps> = ({ instanceId }) => {
    const { t } = useTranslation();
    const { executeAsync, data, isLoading, error } = useAsync<GetOTPResponse>({ isLoading: false });

    const getOTP = async () => {
        const client = new OneTimePasswordClient();
        await executeAsync(async () => client.byInstanceId(instanceId));
    }

    const copyToClipboard = useCallback(() => {
        if (data === undefined) {
            return;
        }

        navigator.clipboard.writeText(data.value);
    }, [data]);

    useEffect(() => {
        if (data?.isValid) {
            copyToClipboard();
        }
    }, [data, copyToClipboard]);

    if (error !== undefined || data?.isValid === false) {
        return (
            <span className="cell--error">
                <span>{error?.message ?? data?.errorMessage}</span>
                <Icon iconName={IconEnum.AlertTriangle} />
            </span>
        )
    }

    if (data === undefined) {
        return <span className={classNames("cell--link", { "loading": isLoading })} onClick={getOTP}>{t('partnerPortal.copyInvitationLink')}</span>
    }

    return (
        <span className="cell--highlight" onClick={copyToClipboard}>
            <Icon iconName={IconEnum.Check} />
            <span>{t('partnerPortal.copiedToClipboard')}</span>
        </span>
    )
};

export default CopyInvitationLink;